import { MessageType } from '@tencent/dz-models';
import Component from './BusinessCard';
// 组件实例
var BusinessCard = Component;
BusinessCard.msgType = MessageType.BusinessCard;
export { BusinessCard };
